import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCheckmark2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"checkmark-2"} maskId="square-filled-radius-0-stroke-1-IconCheckmark2"><path fillRule="evenodd" clipRule="evenodd" d="M22.6457 3.52209L9.4276 21.9048L1.35193 15.963L2.5372 14.3521L8.98423 19.0956L21.0219 2.35449L22.6457 3.52209Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCheckmark2;
